import {Flex, Text} from '@indoqa/style-system'
import {IStyle} from 'fela'
import * as React from 'react'
import {useFela} from 'react-fela'
import {Theme} from '../../../app/theme'
import {ReaderLayoutContext, ReaderLayoutContextValue} from '../../../commons/layouts/reader-layout/ReaderLayoutContext'
import {StructureNode} from '../../../commons/types/Structure'
import {DocsetStructure} from '../../store/kv.types'
import {Hit} from './getHitsFromStructure'
import {useSearchNavigation} from './useSearchNavigation'

interface Props {
  contentRef: React.RefObject<HTMLElement>
  structure: DocsetStructure | StructureNode | null
  paraId?: string
  goToHit: GoToHit
}

export type GoToHit = (hit: Hit) => void

const createButtonStyle = (theme: Theme, disabled: boolean): IStyle => ({
  backgroundColor: disabled ? '#ababab' : theme.colors.primaryLight,
  color: theme.colors.textInverted,
  fontSize: '80%',
  boxShadow: 'none',
  borderWidth: 0,
  cursor: 'pointer',
  paddingTop: theme.spacing.space1,
  paddingRight: theme.spacing.space2,
  paddingBottom: theme.spacing.space1,
  paddingLeft: theme.spacing.space2,
})

export const SearchNavigationBar = ({structure, paraId, goToHit, contentRef}: Props) => {
  const {theme, css} = useFela<Theme>()

  const [hasNext, setHasNext] = React.useState<boolean>(false)
  const [hasPrevious, setHasPrevious] = React.useState<boolean>(false)
  const {setSearchBarHeight, dimensions} = React.useContext<ReaderLayoutContextValue>(ReaderLayoutContext)
  const {goToNext, goToPrevious} = useSearchNavigation(
    structure,
    contentRef,
    paraId,
    goToHit,
    setHasNext,
    setHasPrevious
  )

  React.useEffect(() => {
    setSearchBarHeight(40)
  }, [setSearchBarHeight])

  return (
    <Flex fullWidth bg={theme.colors.bgContentEmphasised} height={`${dimensions.searchBarHeight}px`} center>
      <button onClick={goToPrevious} disabled={!hasPrevious} className={css(createButtonStyle(theme, !hasPrevious))}>
        Zum vorigen Treffer
      </button>
      <Text mx={2}>{/*{currentHitPos + 1} / {hits.length}*/}</Text>
      <button onClick={goToNext} disabled={!hasNext} className={css(createButtonStyle(theme, !hasNext))}>
        Zum nächsten Treffer
      </button>
    </Flex>
  )
}
